export const es: Record<string, string> = {
  yes: "Si",
  deleteQuestion: "¿Desea eliminar este elemento?",
  cancelateQuestion: "¿Desea cancelar esta orden?",
  sameCar: "¿Utilizar el mismo auto?",
  Economico: "Económico",
  Automatico: "Automático",
  AutomaticoSinSeguro: "Automático S/Seguro",
  Open: "Abierta",
  Confirmed: "Confirmada",
  Closed: "Cerrada",
  Accepted: "Aceptada",
  Rejected: "Rechazada",
  Autorized: "Autorizada",
  Pending: "Pendiente",
  ValidationRequired: "Este campo es requerido"
};
